import { createAsyncThunk } from '@reduxjs/toolkit';
import CustomerAPI from 'config/api/CustomerAPI';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';

const normalizePagination = (response: any) => {
  const rawData = response?.data ?? response;
  const pagination = rawData?.pagination || rawData?.meta || {};
  const currentPage = pagination?.page || rawData?.page || rawData?.current_page || 1;
  const totalPages =
    pagination?.total_pages ||
    pagination?.last_page ||
    rawData?.last_page ||
    (pagination?.total && pagination?.limit ? Math.ceil(pagination.total / pagination.limit) : 1);
  const total = pagination?.total || rawData?.total || rawData?.total_records || 0;

  return {
    page: currentPage,
    totalPages,
    total,
  };
};

export const getFeaturedBlogsAPI = createAsyncThunk('customerBlog/featured', async () => {
  try {
    const response: any = await manageAPICall(
      CustomerAPI.blogCommonForFeaturedAndCategory.url,
      CustomerAPI.blogCommonForFeaturedAndCategory.method,
      {}
    );

    if (response?.status === false)
      return { featured_blogs: [], categories: [], authors: [], advertisements: null };
    const responseData = response.data;

    return {
      featured_blogs: responseData.featured_blogs,
      categories: responseData.active_blog_categories,
      authors: responseData.active_blog_authors,
      advertisements: responseData.advertisements,
    };
  } catch {
    return { featured_blogs: [], categories: [], authors: [], advertisements: null };
  }
});

export const getBlogListAPI = async (payload: {
  page?: number;
  limit?: number;
  filters?: { is_featured?: boolean; category?: string; author_slug?: string };
}) => {
  try {
    const response: any = await manageAPICall(
      CustomerAPI.blogList.url,
      CustomerAPI.blogList.method,
      payload
    );

    if (response?.status === false) {
      return {
        data: [],
        pagination: { page: payload.page, totalPages: 1, total: 0 },
        requestedPage: payload.page,
      };
    }

    const data = response?.data?.data ?? [];
    const pagination = normalizePagination(response);

    return {
      data,
      pagination,
      requestedPage: payload.page,
    };
  } catch {
    return {
      data: [],
      pagination: { page: payload.page, totalPages: 1, total: 0 },
      requestedPage: payload.page,
    };
  }
};
export const getSingleBlogInfo = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.singleBlogInfo.url,
    CustomerAPI.singleBlogInfo.method,
    data
  );
  return response;
};

export const subscribeNewsletterAPI = async (data: { email: string }) => {
  const response = await manageAPICall(
    CustomerAPI.subscribeNewsletter.url,
    CustomerAPI.subscribeNewsletter.method,
    data
  );
  return response;
};
